import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import {
  H1,
  YekanParagraph,
} from "../components/typography"
import { BaseContainer } from "../components/container"

const Terms = ({ data }) => {
  const { title, description } = data.contentYaml.content
  return (
    <Layout>
      <SEO slug="/about" />
      <BaseContainer direction="vertical">
        <H1>{title}</H1>
    <YekanParagraph dangerouslySetInnerHTML={{ __html: description}}/>
      </BaseContainer>
    </Layout>
  )
}

export const query = graphql`
  {
    contentYaml(header: { slug: { eq: "/about" } }) {
      content {
        title
        description
      }
    }
  }
`

export default Terms
